var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { omit } from "lodash";
import id from "@irati/utils/id";
var StyledSvg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.greys.mediumDark;
});
var Base = function (props) {
    var idNamespace = id("svg", props);
    var className = props.className, viewBox = props.viewBox, size = props.size, color = props.color, children = props.children, rest = __rest(props, ["className", "viewBox", "size", "color", "children"]);
    return (React.createElement(StyledSvg, __assign({ id: idNamespace, className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: viewBox, width: size, height: size, color: color, preserveAspectRatio: "xMidYMid" }, omit(rest, ["id"])), children));
};
Base.defaultProps = {
    size: 20,
    viewBox: "0 0 20 20"
};
export default Base;
var templateObject_1;
